module.exports = __webpack_public_path__ + "img/US-BUREAU-INDIAN-AFFAIRS.5f018633.png";